import CrudPage from './CrudPage'
import ActionButton from './ActionButton'

export default CrudPage
export {
  ActionButton,
}
